// file: `react/src/pages/UserThreads.tsx`:
// showing user/thread relationships for the threads the current user can see

import React, { useEffect, useState } from 'react';
import { Table, Container } from 'react-bootstrap';
import { expressURL, getAuthHeaders } from "../utils/networkUtils";

interface User {
  id: string | number;
  shortName: string;
}

interface Thread {
  id: number;
  name: string;
}

interface UserThread {
  userId: string | number;
  threadId: number;
}

const UserThreads = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [threads, setThreads] = useState<Thread[]>([]);
  const [userThreads, setUserThreads] = useState<UserThread[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const headers = getAuthHeaders();

      const [usersResponse, threadsResponse, userThreadsResponse] = await Promise.all([
        fetch(`${expressURL()}/api/get-users`, headers),
        fetch(`${expressURL()}/api/get-threads`, headers),
        fetch(`${expressURL()}/api/get-user-threads`, headers)
      ]);

      if (usersResponse.ok && threadsResponse.ok && userThreadsResponse.ok) {
        const usersData: User[] = await usersResponse.json();
        const threadsData: Thread[] = await threadsResponse.json();
        const userThreadsData: UserThread[] = await userThreadsResponse.json();

        setUsers(usersData);
        setThreads(threadsData);
        setUserThreads(userThreadsData);
      } else {
        console.error('Failed to fetch data');
      }
    };

    fetchData();
  }, []);

  const hasAccess = (userId: string | number, threadId: number) => {
    return userThreads.some(ut => String(ut.userId) === String(userId) && Number(ut.threadId) === Number(threadId));
  };

  return (
    <Container>
      <h1>User-Thread Relationships</h1>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>User / Thread</th>
            {threads.map(thread => (
              <th key={thread.id}>{thread.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.shortName}</td>
              {threads.map(thread => (
                <td key={thread.id}>
                  {hasAccess(user.id, thread.id) ? '✔️' : ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default UserThreads;